import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { CheckList } from "./CheckList";
import type { FeatureBlockData } from "../data/content";
export function FeatureBlock({
  block
}: {
  block: FeatureBlockData;
}) {
  return <section className="bg-white px-4 py-16" aria-labelledby={`${block.id}-title`} data-id="element-92" data-mp="4z99b4i46e4b">
      <article className="mx-auto grid max-w-5xl items-center gap-10 rounded-lg border border-brand/40 p-6 md:grid-cols-2 md:p-10" data-id="element-93" data-mp="51dd7mg0jd4l">
        <div className={block.reverse ? "md:order-2" : ""} data-id="element-94" data-mp="wqykqiszc1yn">
          <h2 id={`${block.id}-title`} className="font-heading text-2xl font-bold uppercase leading-tight" data-id="element-95" data-mp="wsjew7bdtivz">
            {block.title} <span className="block text-brand" data-id="element-96" data-mp="ny51ybebqkg1">{block.accent}</span>
          </h2>
          {block.paragraphs.map(p => <p key={p} className="mt-4 text-sm leading-relaxed text-ink-muted" data-id="element-97" data-mp="1bnfuj5lit8j3">{p}</p>)}
          <div className="mt-4" data-id="element-98" data-mp="1geo5i62i11yd">
            <CheckList items={block.checks} columns={block.checkColumns ?? 1} data-id="element-99" data-mp="1gfz7q1gaq1nd" />
          </div>
          {block.afterChecks && <p className="mt-5 text-sm font-medium" data-id="element-100" data-mp="ebgnq1r7o29j">{block.afterChecks}</p>}
          {block.points && <ul className="mt-3 space-y-1.5" data-id="element-101" data-mp="aa4t1hthcquh">
              {block.points.map(p => <li key={p} className="flex items-center gap-2 text-sm" data-id="element-102" data-mp="o5fksmcfgvum">
                  <ArrowRightIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-103" data-mp="jbum0s30fxud" />
                  {p}
                </li>)}
            </ul>}
          {block.closing && <p className="mt-5 font-heading font-bold" data-id="element-104" data-mp="t1nw1oni84wi">{block.closing}</p>}
          {block.cta && <div className="mt-6" data-id="element-105" data-mp="170xdssrcz72l">
              <CtaButton label={block.cta} align="start" data-id="element-106" data-mp="16zujsbyqooig" />
            </div>}
        </div>
        <img src={block.image} alt={block.imageAlt} className={`aspect-[4/3] w-full rounded-lg object-cover ${block.reverse ? "md:order-1" : ""}`} data-id="element-107" data-mp="121az0evvtiro" />
      </article>
    </section>;
}